// components/ErrorBoundary.js

import React from "react";
import Error500 from "src/pages/500";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const extraContext = {
      url: window?.location?.href || "",
      userAgent: navigator?.userAgent || "",
      state: this?.state || "", // Include component state if helpful
      // Add any other relevant details
    };
    fetch("/api/logError", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        error: error.toString(),
        errorInfo: errorInfo.componentStack,
        context: extraContext,
      }),
    });
  }

  render() {
    if (this.state.hasError) {
      return <Error500 />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
